import * as MUTATIONS from './mutation-types'
import {
	FETCH_BANNERS,
	EDIT_BANNER,
	CREATE_BANNER,
	FETCH_BANNER,
	FETCH_ACTIVE_BANNER
	// SET_MODAL
} from './action-types'
import ApolloClient from '@/packages/apollo-client'
import Logger from '@/packages/logger'
// import asd from '@/components/Layout/EditTableModal'

import FetchActiveBanner from './Schema/Queries/FetchActiveBanner.gql'
import FetchBanners from './Schema/Queries/FetchBanners.gql'
import FetchBanner from './Schema/Queries/FetchBanner.gql'

import EditBanner from './Schema/Mutations/EditBanner.gql'
import CreateBanner from './Schema/Mutations/CreateBanner.gql'

export default {

	async [FETCH_BANNER] ({ commit }, id) {
		const query = {
			query: FetchBanner,
			variables: {
				id
			}
		}

		try {
			const { data, errors } = await ApolloClient.query(query)
			if (errors) {
				throw errors
			}
			commit(MUTATIONS.SET_BANNER, data.banner)
			return data.banner
		} catch (e) {
			Logger.captureException(e)
			return Promise.reject(e)
		}

	},

	async [FETCH_BANNERS] ({}, payload) {
		const query = {
			query: FetchBanners,
			variables: {
				...payload
			}
		}

		try {
			const { data, errors } = await ApolloClient.query(query)
			if (errors) {
				throw errors
			}
			return data.banners
		} catch (e) {
			Logger.captureException(e)
			return Promise.reject(e)
		}

	},

	async [FETCH_ACTIVE_BANNER] ({ commit }) {
		const query = {
			query: FetchActiveBanner,
			variables: {
				filter: {
					active: true
				},
				first: 1
			}
		}

		try {
			const { data, errors } = await ApolloClient.query(query)
			if (errors) {
				throw data.errors
			}
			if (data.banners && data.banners.length) {
				commit(MUTATIONS.SET_BANNER, data.banners[0])
				return data.banners[0]
			}
			return null
		} catch (e) {
			Logger.captureException(e)
			return Promise.reject(e)
		}

	},

	async [EDIT_BANNER] ({ dispatch }, payload) {
		const mutation = {
			mutation: EditBanner,
			variables: {
				payload
			}
		}
		try {
			const { data, errors } = await ApolloClient.mutate(mutation)
			if (errors) {
				throw errors
			}
			dispatch(FETCH_BANNER, payload.id)
			return data.editBannerInfo

		} catch (e) {
			Logger.captureException(e)
			return Promise.reject(e)
		}

	},

	async [CREATE_BANNER] ({ dispatch }, payload) {
		const mutation = {
			mutation: CreateBanner,
			variables: {
				payload
			}
		}
		try {
			const { data, errors } = await ApolloClient.mutate(mutation)
			if (errors) {
				throw errors
			}
			dispatch(FETCH_BANNER, data.createBannerInfo.id)
			return data.createBannerInfo
		} catch (e) {
			Logger.captureException(e)
			return Promise.reject(e)
		}
	}
}
